<!-- 线索中心首页 -->
<template>
  <div class="clueCenter">
    <div class="container">
      <!--  头部 -->
      <div class="head">
        <div class="time">
          <el-date-picker
            @change="changeDatePickerTime"
            v-model="datePickerTime"
            type="month"
            value-format="yyyy-MM"
            placeholder="选择时间"
          >
          </el-date-picker>
        </div>
        <div class="information">
          <!-- 总线索数 -->
          <div class="item">
            <div class="icon">
              <img src="../../../assets/icons/all-clue.png" alt="" />
            </div>
            <div class="txt">
              <span>总线索数</span>
            </div>
            <div class="quantity">{{ clueNumber.sumUpNumber }}</div>
          </div>
          <!-- 今日新增线索数 -->
          <div class="item">
            <div class="icon">
              <img src="../../../assets/icons/new-clue.png" alt="" />
            </div>
            <div class="txt">
              <span>今日新增线索数</span>
            </div>
            <div class="quantity">{{ clueNumber.todayNumber }}</div>
          </div>
          <!-- 跟进线索数 -->
          <div class="item">
            <div class="icon">
              <img src="../../../assets/icons/follow-up-clue.png" alt="" />
            </div>
            <div class="txt">
              <span>跟进线索数</span>
            </div>
            <div class="quantity">{{ clueNumber.underwayNumber }}</div>
          </div>
          <!-- 成功线索数 -->
          <div class="item">
            <div class="icon">
              <img src="../../../assets/icons/success-clue.png" alt="" />
            </div>
            <div class="txt">
              <span>成功线索数</span>
            </div>
            <div class="quantity">{{ clueNumber.succeedNumber }}</div>
          </div>
        </div>
      </div>
      <!-- 筛选部分 -->
      <div class="filtratee">
        <!-- 所在城市 -->
        <div class="placeCity">
          <div class="label">所在城市：</div>
          <!-- <div class="unlimited active">不限</div> -->
          <CascaderArea country="中国" province="" city="" @searchArae="searchArae"></CascaderArea>
        </div>
        <!-- 进度 -->
        <div class="schedule">
          <div class="label">进度：</div>
          <div
            class="item"
            :class="item.id == scheduleId ? 'active' : ''"
            v-for="item in scheduleList"
            :key="item.id"
            @click="clickSchedule(item)"
          >
            {{ item.value }}
          </div>
        </div>
        <!-- 优先级 -->
        <div class="priority">
          <div class="label">优先级：</div>
          <div
            class="item"
            :class="item.id == priority ? 'active' : ''"
            v-for="item in priorityList"
            :key="item.id"
            @click="clickPriority(item)"
          >
            {{ item.value }}
          </div>
        </div>
        <!-- 筛选结果 -->
        <!-- <div class="result">
        <div class="label">筛选结果：</div>
        <div class="item" v-for="item in resultList" :key="item.id">
          {{ item.value }}
          <i class="el-icon-close" @click="clickRemove(item)"></i>
        </div>
      </div> -->
      </div>
      <!-- 搜索栏 -->
      <div class="search">
        <div class="left">
          <el-checkbox v-model="searchCheckbox" @change="searchChange">只看有会前通知</el-checkbox>
        </div>
        <div class="right">
          <el-input v-model="searchInputVla" placeholder="请输入相关企业名称"></el-input>
          <div class="icon" @click="clickSearch">
            <i class="el-icon-search"></i>
          </div>
          <div v-if="addHasPermission" class="addClew" @click="clickAddClew()">
            <i class="el-icon-plus"></i>
            <div class="txt">添加线索</div>
          </div>
        </div>
      </div>
      <!-- 内容区域 -->
      <div class="table_card">
        <!-- 表格 -->
        <div class="table">
          <el-table
            ref="multipleTable"
            :data="tableData"
            :header-cell-style="{ background: '#fff', color: '#1A1F33' }"
            tooltip-effect="dark"
            style="width: 100%"
            @sort-change="changeTableSort"
          >
            <el-table-column label="线索编号" align="center">
              <template slot-scope="scope">{{ scope.row.clueCode }}</template>
            </el-table-column>
            <el-table-column
              label="优先级"
              align="center"
              sortable="custom"
              prop="优先级"
              min-width="90px"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.priority == 0">低</div>
                <div v-if="scope.row.priority == 1">中</div>
                <div v-if="scope.row.priority == 2">高</div>
                <div v-if="scope.row.priority == 3">更高</div>
              </template>
            </el-table-column>
            <el-table-column
              label="进度"
              align="center"
              sortable="custom"
              prop="进度"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div class="tabSchedule">
                  <div v-if="scope.row.schedule == 0">
                    <img src="../../../assets/icons/enterprise-import.png" alt="" />
                    <span>企业导入</span>
                  </div>
                  <div v-if="scope.row.schedule == 1">
                    <img src="../../../assets/icons/key-person-import.png" alt="" />
                    <span>关键人导入</span>
                  </div>
                  <div v-if="scope.row.schedule == 2">
                    <img src="../../../assets/icons/linker-import.png" alt="" />
                    <span>链接方导入</span>
                  </div>
                  <div v-if="scope.row.schedule == 3">
                    <img src="../../../assets/icons/enterprise-abutment.png" alt="" />
                    <span>企业对接</span>
                  </div>
                  <div v-if="scope.row.schedule == 4">
                    <img src="../../../assets/icons/enterprise-sign-up.png" alt="" />
                    <span>企业签约</span>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="企业logo" align="center" width="80px">
              <template slot-scope="scope">
                <div class="logoBox">
                  <div class="logo" @click="toParticulars(scope.row)">
                    <img :src="scope.row.logo" alt="" />
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="企业" align="center">
              <template slot-scope="scope">{{ scope.row.enterpriseAbbreviation }}</template>
            </el-table-column>
            <el-table-column label="地点" align="center" min-width="120px">
              <template slot-scope="scope">
                <span>{{ scope.row.nation }}</span>
                <span>{{ '-' + scope.row.province }}</span>
                <span v-if="scope.row.city">
                  {{ '-' + scope.row.city }}
                </span>
              </template>
            </el-table-column>
            <el-table-column label="商务经理" align="center" min-width="100px">
              <template slot-scope="scope">{{ scope.row.englishName }}</template>
            </el-table-column>
            <el-table-column label="线索信息员" align="center" min-width="100px">
              <template slot-scope="scope">{{ scope.row.clueMessenger }}</template>
            </el-table-column>
            <el-table-column label="来源方式" align="center" min-width="80px">
              <template slot-scope="scope">
                <div v-if="scope.row.sourceWay == 0">其他</div>
                <div v-if="scope.row.sourceWay == 1">菁锐大脑</div>
                <div v-if="scope.row.sourceWay == 2">人工导入</div>
                <div v-if="scope.row.sourceWay == 3">合作方提交</div>
              </template>
            </el-table-column>
            <el-table-column label="会前准备" align="center" min-width="80px">
              <template slot-scope="scope">
                <div class="send_inform">
                  <div v-if="scope.row.prepare == 1" @click="sendNotification(scope.row)">
                    发送通知
                  </div>
                  <div v-else-if="scope.row.prepare == 2">已通知</div>
                  <div v-else-if="scope.row.prepare == 3">
                    <div class="prepareUrl" @click="clickOpen(scope.row)">
                      {{ scope.row.prepareUrl | prepareUrlFil }}
                    </div>
                    <i
                      @click="clickDownload(scope.row)"
                      class="el-icon-download"
                      style="margin-left: 6px; color: #4d70fa"
                    ></i>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              align="center"
              sortable="custom"
              prop="创建时间"
              min-width="120px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.createTime | createTime(0) }}</div>
                <div>{{ scope.row.createTime | createTime(1) }}</div>
              </template>
            </el-table-column>
            <el-table-column
              label="最近更新时间"
              align="center"
              sortable="custom"
              prop="最近更新时间"
              min-width="140px"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.updateTime | createTime(0) }}</div>
                <div>{{ scope.row.updateTime | createTime(1) }}</div>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" min-width="100px">
              <template slot-scope="scope">
                <div class="row">
                  <div class="compile" v-if="editHasPermission" @click="clickCompile(scope.row)">
                    编辑
                  </div>
                  <div class="compile" @click="toParticulars(scope.row)">详情</div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 分页器 -->
    <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="query.baseParam.pageNum"
        :page-sizes="[10, 30, 50]"
        :page-size="query.baseParam.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>
    <!-- 编辑对话框区域 -->
    <div class="dialog">
      <el-dialog @close="dialogClose" :visible.sync="dialogVisible" width="50%">
        <div class="dialogHead">
          <div class="line"></div>
          <div class="txt" v-if="echo == 0">新增线索</div>
          <div class="txt" v-else>编辑线索</div>
        </div>
        <div class="form">
          <el-form ref="form" :rules="rules" :model="form" label-width="119px">
            <el-form-item label="企业logo：" prop="logo">
              <uploadLogo
                :imageShow.sync="form.logo"
                @uploadOneImgShow="uploadOneImgShow"
              ></uploadLogo>
            </el-form-item>
            <el-form-item label="企业简称：" prop="enterpriseAbbreviation">
              <el-input
                v-model="form.enterpriseAbbreviation"
                placeholder="请输入企业简称"
              ></el-input>
            </el-form-item>
            <el-form-item label="企业全称：" prop="enterpriseName">
              <el-autocomplete
                class="inline-input"
                v-model="form.enterpriseName"
                :fetch-suggestions="enterpriseNameQuerySearch"
                placeholder="请输入"
                :trigger-on-focus="false"
                @select="enterpriseNameSelect"
                @input="inputChanged"
              ></el-autocomplete>
            </el-form-item>
            <el-form-item label="地点：" prop="enterpriseName">
              <div class="position">
                <CascaderArea
                  :country="form.nation"
                  :province="form.province"
                  :city="form.city"
                  @searchArae="dialogSearchArae"
                ></CascaderArea>
              </div>
            </el-form-item>
            <el-form-item label="来源方式：" prop="sourceWay">
              <div class="sourceWay">
                <div
                  v-for="item in sourceWayList"
                  :key="item.id"
                  class="item"
                  :class="item.id == form.sourceWay ? 'activeSourceWay' : ''"
                  @click="clickSourceWay(item)"
                >
                  {{ item.value }}
                </div>
              </div>
            </el-form-item>
            <el-form-item label="线索信息员：" prop="clueMessenger">
              <el-input v-model="form.clueMessenger" placeholder="请输入线索信息员"></el-input>
            </el-form-item>
            <el-form-item label="商务经理：" prop="englishName" class="commercial_manager">
              <el-select v-model="form.englishName" placeholder="请选择">
                <el-option-group v-for="group in options" :key="group.label" :label="group.label">
                  <el-option v-for="item in group.options" :key="item" :label="item" :value="item">
                  </el-option>
                </el-option-group>
              </el-select>
            </el-form-item>
            <el-form-item label="进度：" prop="schedule" class="commercial_manager">
              <el-select v-model="form.schedule" filterable placeholder="请选择">
                <el-option
                  v-for="item in formScheduleList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="优先级：" prop="priority" class="commercial_manager">
              <el-select v-model="form.priority" filterable placeholder="请选择">
                <el-option
                  v-show="item.id != null"
                  v-for="item in priorityList"
                  :key="item.value"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
          <div class="button">
            <div v-if="echo == 0" class="add" @click="addClue">添加</div>
            <div v-if="echo == 1" class="add" @click="addClue">保存</div>
            <div class="cancel" @click="dialogVisible = false">取消</div>
          </div>
        </div>
      </el-dialog>

      <!-- 手机号弹框 -->
      <el-dialog
        :close-on-click-modal="false"
        style="padding-top: 25vh"
        title="提示"
        :visible.sync="phoneDialog"
        width="421px"
      >
        <div slot="title" class="phoneDialogTitle">
          <div class="line"></div>
          <div class="title">发送通知</div>
        </div>
        <div class="phoneDialog">
          <!-- 操作类容区域 -->
          <div class="phoneDialogFooter">
            <div class="label">手机号</div>
            <el-select
              v-model="optionsValue"
              filterable
              allow-create
              default-first-option
              placeholder="请输入"
            >
              <el-option
                v-for="item in optionsList"
                :key="item.id"
                :label="`${item.userName + '-' + item.mobile}`"
                :value="item.mobile"
              >
              </el-option>
            </el-select>
          </div>
          <!-- 确定取消按钮 -->
          <div class="options">
            <el-button @click="phoneSelect" type="primary">确定</el-button>
            <el-button style="margin-right: 15px" @click="phoneDialog = false">取消</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import CascaderArea from '@/components/CascaderArea'
import uploadLogo from './components/uploadLogo.vue'
import {
  saveClueOne,
  getClueNumber,
  getCluePage,
  getUser,
  updateClue,
  sendNotification
} from '@/api/businessCenter'
import { uploadFile } from '@/api/projectCenter.js'
import { getCompanyNamesLogo } from '@/api/enterprise.js'
import { userList } from '@/api/user.js'

const formObj = Object.freeze({
  accomplishProject: null, // 已完成项目id（,隔开）
  city: '', // 城市
  clueCode: null, // 线索编号
  clueMessenger: '', //   	线索信息员
  createName: '', // 	创建人名字
  createTime: null, //  创建时间
  enterpriseAbbreviation: '', // 企业简称
  enterpriseName: '', // 企业全称
  enterpriseSites: '', // 企业官网
  establishTime: null, // 成立时间
  logo: '', // 企业logo
  nation: '中国', // 国家
  prepare: null, // 会前准备
  prepareUrl: null, // 准备地址
  priority: '', // 优先级别
  province: '北京', // 省份
  schedule: '', // 进度  0->企业导入；1->关键人导入；2->链接方导入；3->企业对接；4->企业签约
  sourceWay: '2', // 来源方式0->其他；1->菁锐大脑；2->人工导入；3->合作方提交；
  statisticsTime: null, // 线索各种数据新增时间
  updateName: null, // 修改人名字
  updateTime: null, // 修改时间
  englishName: null // 商务经理
})
const defaultQueryObj = Object.freeze({
  baseParam: {
    pageNum: 1,
    pageSize: 10
  },
  city: '',
  clueCode: '',
  enterpriseName: '',
  nation: '中国',
  order: 'desc',
  orderType: 2,
  priority: '',
  province: '不限',
  schedule: '',
  isInform: ''
})

export default {
  components: { CascaderArea, uploadLogo },
  data() {
    return {
      query: { ...defaultQueryObj },
      // 头部时间选择
      datePickerTime: '',
      // 进度
      scheduleList: [
        {
          value: '不限',
          id: null
        },
        {
          value: '企业导入',
          id: '0'
        },
        {
          value: '关键人导入',
          id: '1'
        },
        {
          value: '链接方导入',
          id: '2'
        },
        {
          value: '企业对接',
          id: '3'
        },
        {
          value: '企业签约',
          id: '4'
        }
      ],
      // 优先级
      priorityList: [
        {
          value: '不限',
          id: null
        },
        {
          value: '更高',
          id: '3'
        },
        {
          value: '高',
          id: '2'
        },
        {
          value: '中',
          id: '1'
        },
        {
          value: '低',
          id: '0'
        }
      ],
      // 进度选择
      scheduleId: null,
      // 优先级选择
      priority: null,
      // 筛选结果
      resultList: [],
      //  只看有会前通知
      searchCheckbox: false,
      //  搜索框的值
      searchInputVla: '',
      // 表格数据
      tableData: [],
      // 数据总条数
      total: 0,
      // 新增显示的 显示与隐藏
      dialogVisible: false,
      // form  新增线索
      form: { ...formObj },
      rules: {
        enterpriseAbbreviation: [{ required: true, message: '请填写企业简称' }],
        sourceWay: [{ required: true, message: '请选择来源方式' }],
        clueMessenger: [{ required: true, message: '请输入线索信息员' }],
        englishName: [{ required: true, message: '请选择商务经理' }],
        schedule: [{ required: true, message: '请选择进度' }],
        priority: [{ required: true, message: '请选择优先级' }]
      },
      // form --> 来源方式
      sourceWayList: [
        {
          value: '智参中心',
          id: '1'
        },

        {
          value: '人工导入',
          id: '2'
        },

        {
          value: '合作方提交',
          id: '3'
        },
        {
          value: '其他',
          id: '0'
        }
      ],
      // 商务经理 数据源
      // businessManager: [
      //   {
      //     value: 'Amy',
      //     id: 0
      //   },
      //   {
      //     value: 'JANE',
      //     id: 1
      //   },
      //   {
      //     value: '其他',
      //     id: '-1'
      //   }
      // ],
      options: [
        {
          label: '商务经理',
          options: []
        },
        {
          label: '其他经理',
          options: []
        }
      ],
      // form --> 进度
      formScheduleList: [
        {
          value: '企业导入',
          id: '0'
        },
        {
          value: '关键人导入',
          id: '1'
        },
        {
          value: '链接方导入',
          id: '2'
        },
        {
          value: '企业对接',
          id: '3'
        },
        {
          value: '企业签约',
          id: '4'
        }
      ],
      // 新增线索的回显
      echo: null,
      // 获取商务经理和其他经理
      getUserList: [],
      // 线索统计数据
      clueNumber: {},
      // 定时器
      time: null,
      // 手机号弹框
      phoneDialog: false,
      // 手机号列表
      optionsList: [
        {
          value: '18126840388',
          label: '18126840388'
        },
        {
          value: '15646681366',
          label: '15646681366'
        },
        {
          value: '17691655483',
          label: '17691655483'
        }
      ],
      // 发送消息弹窗用户输入的手机号
      optionsValue: [],
      // 点击发送通知，当前这一项的数据
      sendMessageAttach: {},
      enterpriseNameList: [] //查询到的企业名称
    }
  },

  computed: {
    addHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/clue/getUser')
      return hasPermission
    },
    getHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/clue/getKeyPersons')
      return hasPermission
    },
    // /clue/updateClue
    editHasPermission() {
      const userPermissions = JSON.parse(sessionStorage.getItem('menuTree')).flatMap(
        (outerItem) => {
          return outerItem.children.map((item) => item.path)
        }
      )
      const hasPermission = userPermissions.includes('/clue/updateClue')
      return hasPermission
    }
  },
  filters: {
    // 过滤时间
    createTime: function (value, number) {
      if (value) {
        return value.split(' ')[number]
      } else {
        return value
      }
    },
    prepareUrlFil: function (val) {
      let re = val.split('/')
      return re[re.length - 1]
    }
  },
  watch: {},
  created() {
    this.form.clueMessenger = sessionStorage.getItem('userName')
    this.search()
    this.getTime()
  },

  methods: {
    async search() {
      const { data: res } = await getCluePage(this.query)
      if (res.resultCode == 200) {
        this.total = res.data.total
        this.tableData = res.data.list
      }
    },
    //选择企业名称
    async enterpriseNameSelect(item) {
      const { data: res } = await getCompanyNamesLogo({ name: item.value })
      if (res.resultCode === 200) {
        this.form.enterpriseName = res.data[0].companyName
        this.form.logo = res.data[0].logo
        this.enterpriseNameList = []
      }
    },
    //查询企业名称
    async enterpriseNameQuerySearch(str, cb) {
      if (str != '') {
        const { data: res } = await getCompanyNamesLogo({ name: str })
        if (res.resultCode === 200) {
          res.data.forEach((item) => {
            this.enterpriseNameList.push({
              value: item.companyName
            })
          })
          cb(this.enterpriseNameList)
        } else {
          this.$message.error('查询失败！')
        }
      }
    },
    //输入值变化时
    inputChanged() {
      this.enterpriseNameList = []
    },
    // 时间
    async getTime() {
      this.datePickerTime = this.initDay()
      const { data: res } = await getClueNumber({
        time: `${this.datePickerTime}-01`
      })
      if (res.resultCode == 200) {
        this.clueNumber = res.data
      }
    },
    //  当前时间
    initDay() {
      const date = new Date() // 得到当前时间
      const year = date.getFullYear() // 年
      const mont = date.getMonth() + 1 // 月
      const monts = mont < 10 || mont === 0 ? '0' + mont : mont // 月+0
      return `${year}-${monts}`
    },
    // 进度选择
    clickSchedule(item) {
      this.scheduleId = item.id
      let re = true
      this.resultList.forEach((items) => {
        if (items.value == item.value || item.value == '不限') {
          return (re = false)
        }
      })
      if (re) {
        this.resultList.push({
          value: item.value,
          id: this.resultList.length
        })
      }
      this.query.schedule = item.id
      this.search()
    },
    // 优先级
    clickPriority(item) {
      this.priority = item.id
      let re = true
      this.resultList.forEach((items) => {
        if (items.value == item.value || item.value == '不限') {
          return (re = false)
        }
      })
      if (re) {
        this.resultList.push({
          value: item.value,
          id: this.resultList.length
        })
      }
      this.query.priority = item.id
      this.search()
    },
    // 城市选择
    // 查询
    searchArae(val) {
      if (this.time) {
        clearTimeout(this.time)
        this.time = null
      } else {
        this.time = null
      }
      this.time = setTimeout(() => {
        this.query.nation = val.country
        this.query.province = val.province
        this.query.city = val.city
        this.search()
      }, 500)
      // if (val.city != '北京' && val.city != '天津' && val.city != '上海' && val.city != '重庆') {
      //   this.queryInfo.companyCity = val.city
      // }
    },
    // 新增 --> 地点
    dialogSearchArae(val) {
      this.form.nation = val.country
      this.form.province = val.province
      this.form.city = val.city
    },
    // 移除筛选结果
    clickRemove(item) {
      this.resultList.splice(item.id, 1)
      this.resultList.forEach((items, index) => {
        this.resultList[index].id = index
        this.resultList[index].value = items.value
      })
    },
    //  只看有会前通知状态改变的方法
    searchChange() {
      let change = ''
      if (this.searchCheckbox == true) {
        change = '是'
      } else if (this.searchCheckbox == false) {
        change = ''
      }
      this.query.isInform = change
      this.search()
    },
    // 编辑线索
    async clickCompile(row) {
      this.echo = 1
      this.dialogVisible = true
      this.getUserData()
      this.query.clueCode = row.clueCode
      const { data: res } = await getCluePage(this.query)
      if (res.resultCode == 200) {
        this.form = res.data.list[0]
        console.log(this.form)
      }
    },
    handleSizeChange(val) {
      this.query.baseParam.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.query.baseParam.pageNum = val
      this.search()
    },
    // 点击新增线索
    clickAddClew() {
      this.getUserData()
      this.echo = 0
      this.dialogVisible = true
    },
    // 新增显示弹出框关闭的回调
    dialogClose() {
      this.form = {
        accomplishProject: null, // 已完成项目id（,隔开）
        city: '', // 城市
        clueCode: null, // 线索编号
        clueMessenger: '', //   	线索信息员
        createName: '', // 	创建人名字
        createTime: null, //  创建时间
        enterpriseAbbreviation: '', // 企业简称
        enterpriseName: '', // 企业全称
        enterpriseSites: '', // 企业官网
        establishTime: null, // 成立时间
        logo: '', // 企业logo
        nation: '中国', // 国家
        prepare: null, // 会前准备  1. 会前准备  2 已通知 3.已有链接
        prepareUrl: null, // 准备地址
        priority: '', // 优先级别
        province: '北京', // 省份
        schedule: '', // 进度  0->企业导入；1->关键人导入；2->链接方导入；3->企业对接；4->企业签约
        sourceWay: null, // 来源方式0->其他；1->菁锐大脑；2->人工导入；3->合作方提交；
        statisticsTime: null, // 线索各种数据新增时间
        updateName: null, // 修改人名字
        updateTime: null, // 修改时间
        englishName: null // 商务经理
      }
    },
    // 图片上传路径长地址  logo
    uploadOneImgShow(value) {
      this.form.logo = value
    },
    // 选择来源方式
    clickSourceWay(item) {
      this.form.sourceWay = item.id
    },
    // 商务经理选择
    changeBusinessManager() {},
    // form --> 进度
    changeSchedule() {},
    // form --> 优先级
    changePriority() {},
    // 新增线索/编辑线索
    addClue() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          if (this.echo == 0) {
            // 新增
            const userName = sessionStorage.getItem('userName')
            this.form.createName = userName
            this.form.prepare = '1'
            const { data: res } = await saveClueOne(this.form)
            if (res.resultCode == 200) {
              this.$message.success('新增成功')
              this.dialogVisible = false
              this.$router.push({
                path: '/businessCenter/clueCenter'
              })
              this.search()
            }
          } else if (this.echo == 1) {
            // 编辑
            const userName = sessionStorage.getItem('userName')
            this.form.updateName = userName
            const { data: res } = await updateClue(this.form)
            if (res.resultCode == 200) {
              this.$message.success('编辑成功')
              this.dialogVisible = false
              this.query.clueCode = ''
              this.search()
            }
          }
        }
      })
    },
    // 选择时间
    async changeDatePickerTime() {
      let time = `${this.datePickerTime}-01`
      const { data: res } = await getClueNumber({
        time
      })
      if (res.resultCode == 200) {
        this.clueNumber = res.data
      }
    },
    // 表格排序
    changeTableSort(column) {
      if (column.order == 'ascending') {
        this.query.order = 'asc'
      } else if (column.order == 'descending') {
        this.query.order = 'desc'
      }
      if (column.prop == '优先级') {
        this.query.orderType = '0'
      } else if (column.prop == '进度') {
        this.query.orderType = '1'
      } else if (column.prop == '创建时间') {
        this.query.orderType = '2'
      } else if (column.prop == '最近更新时间') {
        this.query.orderType = '3'
      }
      this.search()
    },
    //  获取所有经理
    async getUserData() {
      const { data: res } = await getUser()
      this.options[0].options = res.data.businessManager // 商务经理
      this.options[1].options = res.data.otherManagers // 其他经理
    },
    // 搜索企业
    clickSearch() {
      this.query.enterpriseName = this.searchInputVla
      this.search()
    },
    // 去往线索详情
    toParticulars(row) {
      if (this.getHasPermission) {
        sessionStorage.setItem('row1', JSON.stringify(row))
        this.$router.push({
          path: '/businessCenter/clueCenter/clueParticulars',
          query: {
            row: JSON.stringify(row)
          }
        })
      } else {
        this.$message.warning('暂无权限')
      }
    },
    // 发送通知
    async sendNotification(row) {
      this.sendMessageAttach = row
      let query = {
        pageNum: 0,
        pageSize: 0,
        userName: ''
      }
      const { data: res } = await userList(query)
      if (res.resultCode == 200) {
        this.optionsList = res.data.list
      } else {
        this.$message.error('查询失败！')
      }
      // 开启输入手机号弹框
      this.phoneDialog = true
    },
    // 手机号选择事件
    async phoneSelect() {
      if (this.optionsValue == '') {
        return this.$message({
          message: '请填写手机号',
          type: 'warning'
        })
      }
      let query = {
        businessManager: this.sendMessageAttach.englishName, // 商务经理
        company: this.sendMessageAttach.enterpriseAbbreviation, //   公司名字
        personCode: this.sendMessageAttach.clueCode, // 线索编号
        phone: this.optionsValue // 手机号
      }
      const { data: res } = await sendNotification(query)
      if (res.resultCode == 200) {
        this.$message({
          message: '发送成功',
          type: 'success'
        })
        this.search()
        this.phoneDialog = false
      }
    },
    // 打开新页面查看附件
    async clickOpen(row) {
      window.open(row.prepareUrl, '_blank')
    },
    // 下载
    async clickDownload(row) {
      let re = row.prepareUrl.split('/')
      const { data: res } = await uploadFile(row.prepareUrl)
      if (res) {
        let blob = new Blob([res])
        let href = window.URL.createObjectURL(blob) //创建新的URL表示指定的blob对象
        const a = document.createElement('a') //创建a标签
        a.style.display = 'none'
        a.href = href // 指定下载'链接
        a.download = re[re.length - 1] //指定下载文件名
        // a.download = "test.png";
        a.click() //触发下载
        window.URL.revokeObjectURL(a.href) //释放URL对象
        if (document.body.contains(a)) {
          document.body.removeChild(a) //释放标签
        }
      }
    }
  }
}
</script>
<style scoped lang="less">
.container {
  height: 82vh;
  overflow: scroll;
}
.pagination {
  width: 100%;
  text-align: center;
  margin: 10px 0;
}
.head {
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: 100px;
  background-color: #fff;
  box-sizing: border-box;
  margin-bottom: 12px;
  .time {
    display: flex;
    align-items: center;
    width: 20%;
    height: 100%;
    margin-left: 40px;
    box-sizing: border-box;
    /deep/.el-date-editor {
      width: 150px;
    }
  }
  .information {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 80%;
    box-sizing: border-box;
    /* flex: 1;
    @media (max-width: 1336px) {
      .item {
        margin-right: 74px !important;
      }
    }
    @media (max-width: 1536px) {
      .item {
        margin-right: 134px !important;
      }
    }
    @media (max-width: 1280px) {
      .item {
        margin-right: 74px !important;
      }
    } */
    .item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      .icon {
        width: 22px;
        height: 22px;
        margin-right: 5px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .txt {
        font-size: 14px;
        font-weight: 400;
        color: #000000;
        margin-right: 5px;
      }
      .quantity {
        font-size: 22px;
        font-weight: 500;
        color: #333333;
      }
    }
  }
}
.filtratee {
  background-color: #fff;
  padding: 12px 18px 12px 0;
  margin-bottom: 12px;
  .label {
    display: flex;
    padding-left: 19px;
    box-sizing: border-box;
    width: 96px;
    font-size: 14px;
    color: #1a1f33;
  }
  .unlimited {
    padding: 3px 10px;
    border-radius: 4px;
    font-size: 14px;
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-right: 20px;
  }

  .placeCity {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .select {
      // width: ;
      margin-left: 19px;
      cursor: pointer;
    }

    /deep/.el-icon-arrow-up:before {
      content: '';
    }
    /deep/.el-input__inner {
      width: 150px;
      height: 30px;
      line-height: 30px;
      // border: none;
      border: 1px solid #17757a;
    }
    /deep/.el-input__icon {
      line-height: 30px;
    }
  }
  .schedule {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .item {
      padding: 3px 10px;
      margin-right: 20px;
      cursor: pointer;
      color: #1a1f33;
      font-size: 14px;
    }
  }
  .priority {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;

    .item {
      padding: 3px 10px;
      margin-right: 20px;
      cursor: pointer;
      color: #1a1f33;
      font-size: 14px;
    }
  }
  .result {
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    margin-bottom: 12px;
    .item {
      padding: 3px 10px;
      border-radius: 4px;
      border: 1px solid #17757a;
      color: #17757a;
      margin-right: 8px;
      cursor: pointer;
    }
  }
}
.search {
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 80px 0 60px;
  background-color: #fff;
  .left {
    display: flex;
    justify-content: right;
    /deep/.el-checkbox__label {
      color: #1a1f33;
      font-size: 14px;
    }
  }
  .right {
    display: flex;
    .icon {
      width: 48px;
      height: 32px;
      background-color: #17757a;
      border-top-right-radius: 4px;
      border-bottom-right-radius: 4px;
      transform: translateX(-2px);
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .addClew {
      width: 89px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      background-color: #17757a;
      font-size: 14px;
      border-radius: 4px;
      margin-left: 40px;
      cursor: pointer;
      .txt {
        font-size: 12px;
        margin-left: 3px;
      }
    }
    .el-input {
      width: 289px;
    }
    /deep/.el-input__inner {
      width: 289px;
      height: 32px;
      line-height: 32px;
      border: 1px solid #17757a;
    }
    /deep/.el-icon-search {
      font-size: 16px;
      color: #fff;
    }
  }
}
.table_card {
  display: flex;
  flex-flow: column;
  background-color: #fff;

  .table {
    .logoBox {
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .logo {
        width: 48px;
        height: 48px;
        border-radius: 4px;
        cursor: pointer;

        img {
          width: 100%;
          height: 100%;
        }
      }
    }
    .compile {
      font-size: 14px;
      color: #17757a;
      cursor: pointer;
    }
    .send_inform {
      font-size: 14px;
      color: #17757a;
      cursor: pointer;
      text-decoration: underline;
      .prepareUrl {
        display: inline;
        color: #4d70fa;
      }
    }
    .tabSchedule {
      display: flex;
      align-items: center;
      img {
        width: 14px;
        height: 14px;
        margin-right: 5px;
      }
    }
  }
}
.dialog {
  /deep/.el-dialog__header {
    padding: 0;
  }
  /deep/.el-dialog__body {
    padding: 0 0 30px 0px;
  }
  /deep/.el-input__inner {
    // width: 354px;
    width: 80%;
  }
  @media (min-width: 1920px) {
    /deep/.el-input__inner {
      width: 80%;
    }
  }
  .position {
    /deep/.el-input__inner {
      width: 90px;
    }
    /deep/.middle-select {
      width: 90px !important;
    }
  }
  @media (max-width: 1366px) {
    .sourceWay {
      font-size: 12px !important;
      width: 80% !important;
    }
  }
  .commercial_manager {
    @media (max-width: 1366px) {
      /deep/.el-input__suffix {
        right: 46px;
      }
    }
  }

  .sourceWay {
    width: 80%;
    height: 36px;
    border-radius: 4px;
    border: 1px solid #dcdee0;
    display: flex;
    color: #333333;
    font-size: 14px;
    overflow: hidden;

    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
    .activeSourceWay {
      background-color: #17757a;
      color: #fff !important;
    }
  }

  .dialogHead {
    display: flex;
    align-items: center;
    height: 54px;
    padding-left: 16px;
    .line {
      width: 4px;
      height: 20px;
      background-color: #17757a;
      border-radius: 2px;
      margin-right: 8px;
    }
    .txt {
      color: #333333;
      font-size: 16px;
      font-weight: 500;
    }
  }

  .button {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    .add {
      color: #fff;
      width: 64px;
      height: 33px;
      background-color: #17757a;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      border-radius: 4px;
      cursor: pointer;
    }
    .cancel {
      color: #17757a;
      width: 64px;
      height: 33px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      border-radius: 4px;
      border: 1px solid #17757a;
      margin-left: 34px;
      cursor: pointer;
    }
  }
}

.phoneDialogTitle {
  display: flex;
  align-items: center;
  height: 45px;
  padding: 0px 0 0 19px;

  .line {
    width: 4px;
    height: 20px;
    border-radius: 10px;
    background-color: #17757a;
    margin-right: 8px;
  }
  .title {
    font-size: 16px;
    font-weight: 500;
    color: #333333;
  }
}

.phoneDialog {
  padding-top: 30px;
  .phoneDialogFooter {
    display: flex;
    align-items: center;
    justify-content: center;

    .label {
      color: #333333;
      font-size: 16px;
      margin-right: 12px;
    }
    .label::before {
      content: '*';
      color: #ff3939;
    }
    /deep/.el-input__inner {
      width: 278px;
      height: 40px;
    }
  }
  .options {
    margin-top: 15px;
    padding-right: 35px;
    display: flex;
    flex-direction: row-reverse;
  }
}

.active {
  border-radius: 4px;
  font-size: 14px;
  color: #17757a !important;
  border: 1px solid #17757a;
  display: flex;
  align-items: center;
  cursor: pointer;
}
.row {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-around;
}
.el-autocomplete {
  width: 100%;
}

/* 媒体查询：自适应 */
// 1680x1050 (1680x889)
@media (max-width: 1682px) and (max-height: 890px) {
  .container {
    max-height: 81vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1600x900 (1600x739)
@media (max-width: 1602px) and (max-height: 740px) {
  .container {
    max-height: 78vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1366x768 (1366x607)
@media (max-width: 1368px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x960 (1280x799)
@media (max-width: 1282px) and (max-height: 800px) {
  .container {
    max-height: 80vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x800 (1280x639)
@media (max-width: 1282px) and (max-height: 640px) {
  .container {
    max-height: 74vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x768 (1280x607)
@media (max-width: 1282px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x720 (1280x599)
@media (max-width: 1282px) and (max-height: 600px) {
  .container {
    max-height: 71vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1280x600 (1280x439)
@media (max-width: 1282px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1152x864 (1152x703)
@media (max-width: 1153px) and (max-height: 704px) {
  .container {
    max-height: 77vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 1024x768 (1024x607)
@media (max-width: 1025px) and (max-height: 608px) {
  .container {
    max-height: 73vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}

// 800x600 (800x439)
@media (max-width: 801px) and (max-height: 440px) {
  .container {
    max-height: 63vh !important;
    height: auto; /* 允许容器高度自动调整 */
  }
}
</style>
